import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

/**
 * Componente InspectionAlertComponent
 * Muestra una alerta informativa sobre la posible necesidad de inspección del vehículo
 * @component
 */
@Component({
  selector: 'app-inspection-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './inspection-alert.component.html',
  styleUrl: './inspection-alert.component.scss',
})
export class InspectionAlertComponent {}
